import { ActionFunctionArgs, redirect } from 'react-router-dom';
import { z } from 'zod';
import { RouterContext } from '../../../router';
import {
  FormFieldValidationError,
  parseForm,
  RedirectRequiredError,
  simpleError,
} from '../../../utils';
import { DomainSchema, LoginSchema, Signup } from '../../../validations';
import { processLoginRedirect } from '../redirect-utils';

export type ISignup = z.infer<typeof Signup>;

export type IDomain = z.infer<typeof DomainSchema>;

export type ILogin = z.infer<typeof LoginSchema>;

export const path = 'home';

export const title = 'accessiBe - Signup';

export const description = 'Sign up to accessiBe';

// export function loader({ request }: LoaderFunctionArgs) {
//   const url = new URL(request.url);
//   const invite = url.searchParams.get('invite');

//   if (invite) document.cookie = `invite=${invite};path=/`;

//   return {
//     // ...config({ layout: 'auth' }),
//     invite,
//   };
// }

export async function POST(params: ActionFunctionArgs, context: RouterContext) {
  const formData = await params.request.formData();
  const identity = parseForm<ISignup>(formData);
  const hash = formData.get('hash')?.toString();

  const result = Signup.safeParse(identity);

  if (!result.success) {
    return result.error.format();
  }

  try {
    // await context.auth.signup(identity);

    // await context.queryClient.invalidateQueries(['me']);
    // const [firstName, ...lastNames] = identity.fullName.split(' ');
    // const lastName = lastNames.pop();
    // const countryCode = countries
    //   .find((country) => country.shortCode === identity.countryCode)
    //   ?.code.replace('+', '');
    // context.analytics.googleTagManager.pushToDataLayer({
    //   idnt_fname: firstName.toLowerCase(),
    //   idnt_lname: lastName?.toLowerCase() ?? null,
    //   idnt_email: identity.email.toLowerCase(),
    //   idnt_phone: identity.phoneNumber,
    //   idnt_phone_country_code: countryCode,
    //   event_name: 'sign_up',
    //   event: 'fireEvent',
    // });
    // await context.queryClient.invalidateQueries(['me']);
    // context.queryClient.removeQueries(['me']);
    return processLoginRedirect(new URL(params.request.url), hash);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (err: any) {
    if (err instanceof FormFieldValidationError) {
      return simpleError<ISignup>(err.field! as keyof ISignup, err.message);
    }
    if (err instanceof RedirectRequiredError) {
      return redirect(err.url);
    }
    return simpleError('email', 'ERRORS.GENERAL_ERROR');
  }
}
